import request from '@/utils/request';
import { calculateParams } from '@/utils/calculations';

/* eslint-disable */
const actions = {
  async getPages({ dispatch, commit, getters }, params) {
    try {
      await commit('updateIsLoading', { isLoading: true });

      const newParams = calculateParams(getters['getPaginationParams'], params);

      await commit('setPaginationParams', newParams);

      const { data } = await request.get('/pages', {
        params: newParams,
      });

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      const pagesFiltered = data.pages.data.filter(
        page =>
          page.title !== 'Τρόποι αποστολής' &&
          page.title !== 'Τρόποι πληρωμής' &&
          page.title !== 'Πολιτική αποστολών' &&
          page.title !== 'Πολιτική επιστροφών',
      );

      const pages = {
        ...data.pages,
        data: pagesFiltered,
      };

      await commit('setData', pages);

      await commit('updateIsLoading', { isLoading: false });
    } catch (err) {
      await commit('updateIsLoading', { isLoading: false });

      throw err;
    }
  },
};

export default actions;
